<template>
  <div class="order-feed-back">
    <el-tooltip effect="light" placement="top-start">
      <template v-if="this.feedback.length!=0">
        <template v-if="this.feedback[this.feedback.length-1].command_state==3">
          <div slot="content" style="color: red;">
            {{`${$t('terminal.command')}[${$t(this.feedback[this.feedback.length-1].command_type)}]${$t('terminal.isSent')}【${this.feedback[this.feedback.length-1].device_name}】${$t('terminal.execFail')}`}}
          </div>
        </template>
        <template v-if="this.feedback[this.feedback.length-1].command_state==2">
          <div slot="content" style="color: green;">
            {{`${$t('terminal.command')}[${$t(this.feedback[this.feedback.length-1].command_type)}]${$t('terminal.isSent')}【${this.feedback[this.feedback.length-1].device_name}】${$t('terminal.execSuccess')}`}}
          </div>
        </template>
        <template v-if="this.feedback[this.feedback.length-1].command_state==1">
          <div slot="content">
            {{`${$t('terminal.command')}[${$t(this.feedback[this.feedback.length-1].command_type)}]${$t('terminal.isSent')}【${this.feedback[0].device_name}】${$t('terminal.sented')}`}}
          </div>
        </template>

      </template>
      <template v-else>
        <div slot='content'>
          {{$t('terminal.noOrderExc')}}
        </div>
      </template>
      <el-popover placement="top-start" width="600" trigger="click">
        <el-table :data="feedback|order" height="300px" :header-cell-style="getRowClass">
          <el-table-column width="170" property="create_time" :label="$t('terminal.createTime')">
          </el-table-column>
          <el-table-column width="100" property="command_type" :label="$t('terminal.orderName')">
            <template slot-scope="scope">
              {{$t(scope.row.command_type)}}
            </template>
          </el-table-column>
          <el-table-column width="170" property="device_name" :label="$t('terminal.aimDevice')">
          </el-table-column>
          <el-table-column width="150" :label="$t('terminal.orderStatus')">
            <template slot-scope="scoped">
              <span v-if="scoped.row.command_state==3" style="color: red;">{{$t('terminal.timeOut')}}!</span>
              <span v-if="scoped.row.command_state==2" style="color: green;">{{$t('terminal.excSuccess')}}</span>
              <span v-if="scoped.row.command_state==1">{{$t('terminal.sent')}}</span>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="this.feedback.length==0">
          <span slot="reference" class="oveflow_text">
            =={{$t('terminal.noOrderExc')}}==
          </span>
        </template>
        <template v-else>
          <span class="oveflow_text" slot="reference" v-if="this.feedback[this.feedback.length-1].command_state==3" style="color: red;">{{`${$t('terminal.command')}[${$t(this.feedback[this.feedback.length-1].command_type)}]${$t('terminal.isSent')}【${this.feedback[this.feedback.length-1].device_name}】${$t('terminal.execFail')}!`}}</span>
          <span class="oveflow_text" slot="reference" v-if="this.feedback[this.feedback.length-1].command_state==2" style="color: green;">{{`${$t('terminal.command')}[${$t(this.feedback[this.feedback.length-1].command_type)}]${$t('terminal.isSent')}【${this.feedback[this.feedback.length-1].device_name}】${$t('terminal.execSuccess')}`}}</span>
          <span class="oveflow_text" slot="reference" v-if="this.feedback[this.feedback.length-1].command_state==1">{{`${$t('terminal.command')}[${$t(this.feedback[this.feedback.length-1].command_type)}]${$t('terminal.isSent')}【${this.feedback[this.feedback.length-1].device_name}】${$t('terminal.sented')}`}}</span>
        </template>

      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
import superClone from '@/assets/scripts/superClone.js';
export default {
  name: "OrderFeedBack",
  props: {
    feedback: {
      type: Array
    }
  },
  filters: {
    order(list) {
      return superClone(list).sort((a, b) => b.command_id - a.command_id);
    }
  },
  methods: {
    getRowClass({
      rowIndex
    }) {
      if (rowIndex == 0) {
        return 'color:rgb(0, 0, 0);font-weight:bold'
      } else {
        return ''
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.order-feed-back {
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
